<template>
  <div class="tx-products module-filter-bar">
    <div class="filter-bar__wrapper">
      <div class="filter-bar__l1-wrapper">
        <div class="filter-bar__l1-wrapper-close icon-close-x-after" @click="openMobileFilterBar"><span>{{ $t('productList.filter.open') }}</span></div>
        <div class="label__open-filter-mobile" @click="openMobileFilterBar"><span class="icon-filter-before">{{ $t('productList.filter.open') }}</span></div>
        <Level1Filter
          v-for="(level1, index) in categories"
          :level1="level1"
          :opened="opened === index"
          :key="'level1-' + index"
          @openDropdown="opened=index"
          @closeDropdown="opened=-1"/>
      </div>
        <ProductSorting
          :opened="opened === -2"
          @openDropdown="opened= -2"
          @closeDropdown="opened=-1"
          @checkboxChange="triggerSorting()"/>
    </div>
    <div class="current-filters__wrapper">
      <div class="active__filter" v-for="(activeFilter, index) in filterCategories" :key="'activeFilter-' + index" @click="deleteFilter(activeFilter)">
        <span class="icon-close-x-after">{{ activeFilter.label }}</span>
      </div>
      <div class="delete-all-filters" :class="{'-inactive': filterCategories.length === 0}" @click="deleteAllFilters"><span>{{ $t('productList.filter.deleteAll') }}</span></div>
    </div>
  </div>
</template>

<script>

import { mapActions, mapState } from 'vuex'
import Level1Filter from '@/components/Level1Filter'
import ProductSorting from '@/components/ProductSorting'

export default {
  name: 'FilterBar',
  components: {
    ProductSorting,
    Level1Filter
  },
  data () {
    return {
      opened: -1,
      openMobile: false
    }
  },
  computed: {
    ...mapState({
      categories: state => state.filter.categories,
      filterCategories: state => state.filter.filterCategories
    })
  },
  watch: {
    opened: function (newOpened) {
      if (newOpened !== -1) {
        document.addEventListener('click', this.closeDropdown)
      }
    }
  },
  methods: {
    ...mapActions([
      'filterProducts'
    ]),
    deleteAllFilters () {
      this.opened = -1
      this.$store.commit('filter/clearFilterCategories')
    },
    deleteFilter (filterToDelete) {
      this.opened = -1
      this.$store.commit('filter/removeFilterCategory', filterToDelete)
      this.filterProducts()
    },
    triggerSorting () {
      this.filterProducts()
    },
    closeDropdown (event) {
      if (this.checkEvent(event.path)) {
        this.opened = -1
        document.removeEventListener('click', this.closeDropdown)
      }
    },
    checkEvent (path) {
      for (let i = 0; i < path.length; i++) {
        if (path[i].className === 'level1__categories-wrapper' ||
          path[i].className === 'tx-products module-filter-level1 -open' ||
          path[i].className === 'tx-products module-filter-sorting -open') {
          return false
        }
      }
      return true
    },
    closeMobileDropdown (event) {
      if (this.checkMobileEvent(event.path)) {
        this.openMobileFilterBar()
        document.removeEventListener('click', this.closeMobileDropdown)
      }
    },
    checkMobileEvent (path) {
      for (let i = 0; i < path.length; i++) {
        if (path[i].className === 'filter-bar__l1-wrapper' || path[i].className === 'filter-bar__l1-wrapper -open' || path[i].className === 'module-filter-level1' || path[i].className === 'label__open-filter-mobile') {
          return false
        }
      }
      return true
    },
    openMobileFilterBar () {
      const filterBarWrapper = document.getElementsByClassName('filter-bar__wrapper')[0]
      if (this.openMobile) {
        filterBarWrapper.classList.remove('-open')
        document.removeEventListener('click', this.closeMobileDropdown)
        this.openMobile = false
      } else {
        filterBarWrapper.classList.add('-open')
        document.addEventListener('click', this.closeMobileDropdown)
        this.openMobile = true
      }
    }
  }
}
</script>
